import React from 'react';
import { CHAT_DURATION_SECONDS } from '../../gameConfig';
import './DebateEngagementNotice.css';

const debateMinutes = Math.round(CHAT_DURATION_SECONDS / 60);

const DebateEngagementNotice: React.FC = () => (
  <div className="debate-engagement-notice-wrap">
    <div className="debate-engagement-notice">
      <ul className="debate-engagement-notice-list">
        <li>
          We&apos;ll ask follow-up questions after the discussion, and thoughtful participation may earn a{' '}
          <strong>bonus</strong>.
        </li>
        <li className="debate-engagement-notice-item--warn">
          Consistent participation is required; failure to engage may result in task rejection.
        </li>
        <li className="debate-engagement-notice-item--green">
          After the {debateMinutes}-minute discussion, you will play <strong>only one</strong> investment round with your partner.
        </li>
      </ul>
    </div>
  </div>
);

export default DebateEngagementNotice;
